import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UtilitiesService } from '../utilities/utilities.service';

@Injectable({
  providedIn: 'root',
})
export class ShippingService {
  shippingAddress: any;

  private httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };
  selectedAddress: any;
  constructor(private http: HttpClient, private UTS: UtilitiesService) {}
  setShipping(shippingAddress) {
    this.shippingAddress = shippingAddress;
  }
  getShipping() {
    return this.shippingAddress;
  }

  getShippingAddress(){
    return this.http.get(
      `${environment.ESHOP_URL}/getShippingAddress.service`,
      this.httpOptions
    );
  }
  getUserAddress_Stub(): Observable<any>  {
    return this.http.get("./assets/stubs/userAddress.json");
  }
  getUserAddress() {
    return this.http.post(
      `${environment.ECARE_URL}/getUserAddress.service`,
      {},
      this.httpOptions
    );
  }
  getSelectedAddress() {
    return this.http.get(
      `${environment.ESHOP_URL}/getSelectedAddress.service`,
      this.httpOptions
    );
  }
  updateAddress(payload){
      return this.http.post(
        `${environment.ESHOP_URL}/updateaddress.service`,
        payload,
        this.httpOptions
      );
  }
  addaddress(payload) {
    return this.http.post(
      `${environment.ESHOP_URL}/addaddress.service`,
      payload,
      this.httpOptions
    );
  }

  updateaddress(payload) {
    return this.http.post(
      `${environment.ESHOP_URL}/updateaddress.service`,
      payload,
      this.httpOptions
    );
  }
  storeNotLoggedInAddress(payload) {
    return this.http.post(
      `${environment.ESHOP_URL}/storeNotLoggedInAddress`,
      payload,
      this.httpOptions
    );
  }
  
  storeSelectedAddress(payload) {
    return this.http.post(
      `${environment.ESHOP_URL}/storeSelectedAddress`,
      payload,
      this.httpOptions
    );
  }

  saveShippmentGroups(payload) {
    return this.http.post(
      `${environment.ESHOP_URL}/saveShippmentGroups`,
      payload,
      this.httpOptions
    );
  }

  deleteaddress(payload) {
    return this.http.post(
      `${environment.ECARE_URL}/eshop/deleteaddress.service`,
      payload,
      this.httpOptions
    );
  }

  deleteaddressOnNotLogin(){
    return this.http.get(
      `${environment.ECARE_URL}/eshop/deleteNotLoggedInAddress.service`,
    );
  }
  setSelectedShipping(shipping){
    this.selectedAddress = shipping;
  }
  getSelectedShipping(){
    return this.selectedAddress;
  }
  updateContectInfo(payload){
    return this.http.post(
      `${environment.ESHOP_URL}/updateContactDetails`,
      payload,
      this.httpOptions
    );
  }
}
